// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3rVB2","box":"WorkspacesBox_box__1uOTX","node":"WorkspacesBox_node__2CIoV"};